export class User {
    email :string;
    password : string;
    confirmPassword : string;
    phoneNumber : string;
    address : string;
    userType : string;
    fullName : string;
    vendorCode : string;
    type : string;
    isActive : string;
    createdBy : string;
    createdOn : string;
    updatedBy : string;
    updatedOn : string;
    registerCode : string;
    error : string;
    changesAllow : boolean;
    roleId : number;
    roleType : string;
}

